import * as tslib_1 from "tslib";
import { MockNotification } from './MockNotification';
import { tryDisableAllWebPushNotifications } from '../actions/disableAllWebPushNotifications';
import { saveWebPushNotificationsOptionsQuick } from '../actions/saveWebPushNotificationsOptions';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { OptionDescription } from 'owa-options-controls';
import { format } from 'owa-strings';
import strings from 'owa-strings/owa-options-strings';
import { getHostLocation } from 'owa-url/lib/hostLocation';
import { isBrowserChrome, isMac } from 'owa-user-agent';
import { getLocalWebPushUserSettingStore, } from 'owa-webpush-notifications';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';
import { getOptionsForFeature, OwsOptionsFeatureType, } from 'owa-outlook-service-options';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
var NotificationOptionsFull = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationOptionsFull, _super);
    function NotificationOptionsFull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotificationOptionsFull.prototype.render = function () {
        var _a = this.props, userOptions = _a.userOptions, localWebPushUserSetting = _a.localWebPushUserSetting;
        var hostname = getHostLocation().hostname;
        return (React.createElement("div", null,
            React.createElement(OptionDescription, null, format(strings.webpushFullSettingsBody, hostname)),
            React.createElement(MockNotification, { browser: isBrowserChrome() ? 'chrome' : 'firefox', os: isMac() ? 'osx' : 'windows', title: strings.webpushMockNotificationSender, body: strings.webpushMockNotificationSubject, url: hostname }),
            React.createElement(OptionDescription, null,
                "When ",
                hostname,
                " is closed:"),
            React.createElement(Toggle, { onText: strings.webpushFullSettingsNewMessageOption, offText: strings.webpushFullSettingsNewMessageOption, checked: userOptions.enabled && localWebPushUserSetting.enabled, onChanged: saveWebPushNotificationsOptionsQuick }),
            React.createElement(TooltipHost, { content: !userOptions.enabled ? strings.webpushFullSettingsDisableAllToolTip : '' },
                React.createElement(Link, { onClick: tryDisableAllWebPushNotifications, disabled: !userOptions.enabled }, strings.webpushFullSettingsDisableAll))));
    };
    NotificationOptionsFull = tslib_1.__decorate([
        reactive({
            userOptions: function () {
                return getOptionsForFeature(OwsOptionsFeatureType.WebPushNotifications);
            },
            localWebPushUserSetting: function () { return getLocalWebPushUserSettingStore(); },
        })
    ], NotificationOptionsFull);
    return NotificationOptionsFull;
}(React.Component));
export default NotificationOptionsFull;
//# sourceMappingURL=NotificationOptionsFull.js.map